.altBadge {
  position: absolute;
  bottom: 8px;
  inset-inline-end: 8px;
}
